import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  DpButton,
  DropdownBar,
  FlexContainer,
  HeaderText,
  Text
} from './General.style';
import DynamicSVGIcon from '../../../Common/DynamicSVGIcon';
import { DropDownArrow } from '../../../../assets/icons';
import { LANGUAGES } from '../../../../constants';
import { useActions } from '../../../../store/hooks/useActions';
import DropDownModal from '../../../Common/DropDownModal/DropDownModal';
import Toast from '../../../Common/Toast';
import { BtnWrapper } from '../../../Common/PopUpModal/Modal.style';
import ButtonComp from '../../../Common/Button/Button.view';
import { getStringLocale } from '../../../../constants/language';
import { Creators as LayoutCreators } from '../../../../views/Layout/store';

const General = () => {
  const { language } = useSelector((state) => state.configData);

  const dispatch = useDispatch();

  const { userData } = useSelector((state) => state.loginData);

  const [modifiedLanguageData, setModifiedLanguageData] = useState([]);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [changedLanguage, setChangedLanguage] = useState(
    modifiedLanguageData[0]
  );

  const { availableLanguages, message, userLanguagePreference } = useSelector(
    (state) => state.localeStrings
  );

  const {
    getAvailableLanguages,
    updateUserLanguagePreference,
    clearSuccessMessage
  } = useActions();

  const tranformLanguageData = (data) =>
    data.map((item) => ({
      id: item.langId,
      value: item.langKey,
      label: item.langName
    }));

  useEffect(() => {
    const modifiedLanguageData = tranformLanguageData(availableLanguages);
    setModifiedLanguageData(modifiedLanguageData);

    const prefferedLanguage = modifiedLanguageData.filter(
      (lang) => lang.value === userLanguagePreference
    )[0];

    setChangedLanguage(prefferedLanguage || modifiedLanguageData[0]);
  }, [availableLanguages]);

  useEffect(() => {
    getAvailableLanguages();
  }, []);

  const handleLanguageUpdate = (item) => {
    const payload = {
      userId: userData?.userId,
      langKey: item?.value
    };
    updateUserLanguagePreference(payload);
  };

  const closeModal = () => {
    dispatch(LayoutCreators.settingsActiveMenu(''));
  };

  return (
    <>
      <HeaderText>Themes</HeaderText>
      <FlexContainer>
        <Text>Default</Text>
        <Text>Dark</Text>
      </FlexContainer>
      <HeaderText>Languauge</HeaderText>

      <DropDownModal
        data={modifiedLanguageData}
        isActive={showLanguageDropdown}
        setModalIsVisibal={() => setShowLanguageDropdown(false)}
        ContainerStyle={{ width: '15rem' }}
        handleClick={(item) => {
          setShowLanguageDropdown(false);
          // handleLanguageUpdate(item);
          setChangedLanguage(item);
        }}
        label='label'
        width='15rem'
      >
        <DropdownBar
          onClick={() => {
            setShowLanguageDropdown(!showLanguageDropdown);
          }}
        >
          {changedLanguage?.label}
          <DpButton>
            <DynamicSVGIcon iconUrl={DropDownArrow} width='2.4rem' />
          </DpButton>
        </DropdownBar>
      </DropDownModal>

      <div style={{ marginTop: '30rem' }}>
        <BtnWrapper
          className='bottom'
          style={{ justifyContent: 'center', gap: '2rem' }}
        >
          {/* <ButtonComp onClick={closeModal} style={{ minWidth: '10rem' }}>
            {getStringLocale('Cancel')}
          </ButtonComp> */}
          <ButtonComp
            style={{ minWidth: '10rem' }}
            dark
            onClick={() => {
              handleLanguageUpdate(changedLanguage);
            }}
          >
            {getStringLocale('Save')}
          </ButtonComp>
        </BtnWrapper>
      </div>
      {message && (
        <Toast
          style={{ right: 20 }}
          fn={() => {
            clearSuccessMessage('');
          }}
          header='Success'
          message={message}
        />
      )}
    </>
  );
};

export default General;
